import CircularProgress from '@mui/material/CircularProgress'
import { NotificationUI } from 'features/notifications'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { appConnector } from 'shared/connector'
import { useSwitcher } from 'shared/hooks'

import { teams } from '../../actions/teams'
import ModalVerified from '../molecules/ModalVerified'
import ModalVerifiedError from '../molecules/ModalVerifiedError'

export function InvitationCallback() {
	const notification = useSwitcher(false)
	const preloader = useSwitcher(false)
	const location = useLocation()

	const code = location.search.slice(6)

	const [response, setResponse] = useState<any>('')
	const [error, setError] = useState<any>('')
	useEffect(() => {
		acceptInvitation(code)
	}, [code])

	async function acceptInvitation(code: string) {
		preloader.on()
		try {
			const response = await teams.acceptInvitation(code)
			setResponse(response)

			if (response?.status === 200) {
				notification.on()
			}
			await appConnector.auth.refreshAccessToken()
		} catch (error) {
			setError((error as any).message)
		} finally {
			preloader.off()
		}
	}

	return (
		<>
			{notification.isOn && response?.status === 200 ? (
				<ModalVerified />
			) : (
				<ModalVerifiedError
					errorText={error}
					isLoadingAcceptInvitation={preloader.isOn}
				/>
			)}
			<div className='auth-call-back-preloader'>
				<div className='auth-call-back-preloader-header'>
					<NotificationUI.Notification />
				</div>
				<div className='auth-call-back-preloader-body'>
					{preloader.isOn && (
						<div className='table-material-loader-wrapper'>
							<CircularProgress
								classes={{ colorPrimary: 'material-loader' }}
								color='primary'
								size={60}
							/>
						</div>
					)}
				</div>
			</div>
		</>
	)
}
